import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68'),
	() => import('./nodes/69'),
	() => import('./nodes/70'),
	() => import('./nodes/71'),
	() => import('./nodes/72'),
	() => import('./nodes/73'),
	() => import('./nodes/74'),
	() => import('./nodes/75'),
	() => import('./nodes/76')
];

export const server_loads = [0,2,3,4,8,9,10,11,12,16,18];

export const dictionary = {
		"/": [~19],
		"/acceptable-use": [20,[2]],
		"/account": [21,[3]],
		"/account/[tabId]": [~22,[3]],
		"/app": [23,[4]],
		"/app/account": [~24,[4,5]],
		"/app/account/[tabId]": [25,[4,5]],
		"/app/books": [26,[4]],
		"/app/books/[transcriptId]": [27,[4]],
		"/app/books/[transcriptId]/[tabId]": [28,[4]],
		"/app/calendar": [29,[4]],
		"/app/calendar/[calendarGrain]": [30,[4]],
		"/app/docs": [31,[4]],
		"/app/docs/[transcriptId]": [32,[4]],
		"/app/docs/[transcriptId]/[tabId]": [33,[4]],
		"/app/drive": [34,[4]],
		"/app/drive/editor/[draftType]": [37,[4,6]],
		"/app/drive/editor/[draftType]/[draftId]": [38,[4,6]],
		"/app/drive/new": [39,[4]],
		"/app/drive/[itemId]": [35,[4]],
		"/app/drive/[itemId]/[tabId]": [36,[4]],
		"/app/home": [40,[4,7]],
		"/app/home/[workspaceId]": [41,[4,7]],
		"/app/home/[workspaceId]/[tabId]": [42,[4,7]],
		"/app/start": [43,[4]],
		"/app/start/task-plan/[id]": [44,[4]],
		"/app/tasks": [45,[4]],
		"/app/tasks/[tabId]": [46,[4]],
		"/app/threads": [47,[4]],
		"/app/threads/[threadId]": [48,[4]],
		"/app/threads/[threadId]/[tabId]": [49,[4]],
		"/blog": [~50,[8]],
		"/blog/post/[slug]": [~51,[8]],
		"/calendar/callback/google": [~52,[9]],
		"/calendar/redirect/google": [~53,[9]],
		"/calendar/success": [~54,[9]],
		"/checkout": [~55,[10]],
		"/checkout/success": [56,[10]],
		"/completeSignIn": [~57,[11]],
		"/contact-team-confirmed": [59],
		"/contact-team": [58],
		"/docs/success": [60],
		"/downloading": [62],
		"/download": [~61],
		"/email/success": [~63],
		"/help": [~64,[12]],
		"/help/article/[slug]": [~65,[12]],
		"/pricing": [66],
		"/privacy-policy": [~67,[13]],
		"/protected": [~68,[14]],
		"/protected/calendar": [69,[14]],
		"/sign-in": [~70,[15]],
		"/sign-up": [~71,[16]],
		"/terms-of-service": [~72,[17]],
		"/tracker/linear/callback": [~73],
		"/tracker/linear/redirect": [~74],
		"/tracker/linear/success": [~75],
		"/welcome": [76,[18]]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';